var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 25,
  fill: "none",
  viewBox: "0 0 24 25"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  width: 24,
  height: 25,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 .5h24v24H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M5 19.5h1.4l8.625-8.625-1.4-1.4L5 18.1zM19.3 9.425l-4.25-4.2 1.4-1.4a1.92 1.92 0 0 1 1.413-.575q.837 0 1.412.575l1.4 1.4q.574.575.6 1.388A1.8 1.8 0 0 1 20.725 8zM17.85 10.9 7.25 21.5H3v-4.25l10.6-10.6z"
}))));
export { SvgEdit as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9ImVkaXQiPgo8bWFzayBpZD0ibWFzazBfMjc4OV85MzY2IiBzdHlsZT0ibWFzay10eXBlOmFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIwIiB5PSIwIiB3aWR0aD0iMjQiIGhlaWdodD0iMjUiPgo8cmVjdCBpZD0iQm91bmRpbmcgYm94IiB5PSIwLjUiIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0iI0ZGRkZGRiIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazBfMjc4OV85MzY2KSI+CjxwYXRoIGlkPSJlZGl0XzIiIGQ9Ik01IDE5LjVINi40TDE1LjAyNSAxMC44NzVMMTMuNjI1IDkuNDc1TDUgMTguMVYxOS41Wk0xOS4zIDkuNDI1TDE1LjA1IDUuMjI1TDE2LjQ1IDMuODI1QzE2LjgzMzMgMy40NDE2NyAxNy4zMDQyIDMuMjUgMTcuODYyNSAzLjI1QzE4LjQyMDggMy4yNSAxOC44OTE3IDMuNDQxNjcgMTkuMjc1IDMuODI1TDIwLjY3NSA1LjIyNUMyMS4wNTgzIDUuNjA4MzMgMjEuMjU4MyA2LjA3MDgzIDIxLjI3NSA2LjYxMjVDMjEuMjkxNyA3LjE1NDE3IDIxLjEwODMgNy42MTY2NyAyMC43MjUgOEwxOS4zIDkuNDI1Wk0xNy44NSAxMC45TDcuMjUgMjEuNUgzVjE3LjI1TDEzLjYgNi42NUwxNy44NSAxMC45WiIgZmlsbD0iI0ZGRkZGRiIvPgo8L2c+CjwvZz4KPC9zdmc+Cg==";